var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498 516 l4 -124 -33 -46 c-23 -33 -49 -54 -87 -71 -65 -30 -82 -32 -29 -4 56 30 44 32 -16 3 -51 -25 -52 -27 -52 -68 0 -37 -3 -43 -20 -42 -14 1 -21 10 -25 31 -5 27 -9 30 -47 33 -38 3 -43 1 -49 -22 -6 -24 -10 -26 -65 -26 l-59 0 0 -45 0 -45 55 0 c30 0 55 -4 55 -10 0 -5 20 -10 45 -10 25 0 45 4 45 9 0 5 20 14 45 20 42 10 47 16 69 64 12 28 31 58 40 66 15 13 22 9 66 -35 48 -47 50 -51 56 -121 6 -62 10 -73 25 -73 18 0 19 14 19 300 l0 300 34 0 c29 0 46 13 46 36 0 2 -28 4 -63 4 l-63 0 4 -124z m82 104 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-89 -308 c-13 -4 -15 -39 -2 -44 5 -1 7 -15 4 -31 -4 -22 -8 -25 -20 -16 -33 28 -34 47 -6 98 26 47 28 48 31 23 2 -14 -1 -28 -7 -30z m-311 -122 c0 -11 -7 -20 -15 -20 -8 0 -15 9 -15 20 0 11 7 20 15 20 8 0 15 -9 15 -20z m50 -9 c0 -24 -3 -28 -20 -24 -13 3 -20 14 -20 29 0 17 6 24 20 24 15 0 20 -7 20 -29z m67 7 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 345 c0 -48 2 -55 20 -55 18 0 20 7 20 55 0 48 -2 55 -20 55 -18 0 -20 -7 -20 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 218 c0 -9 -7 -19 -13 -21 -7 -3 5 -5 27 -5 22 0 30 3 18 5 -12 2 -24 12 -26 21 -4 16 -5 16 -6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 45 c-12 -31 7 -35 171 -35 165 0 180 3 167 38 -7 19 -331 17 -338 -3z m326 -10 c0 -6 -58 -10 -155 -10 -97 0 -155 4 -155 10 0 6 58 10 155 10 97 0 155 -4 155 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle10);
export default __webpack_public_path__ + "static/media/vehicle10.e897c987bd5d28ba5b13838145fea4be.svg";
export { ForwardRef as ReactComponent };